import { Pipe, PipeTransform, inject } from '@angular/core';
import { HelperService } from '../services/helper.service';

@Pipe({ name: 'convertDateToTime' })
export class ConvertDateToTimePipe implements PipeTransform {
  private helperService = inject(HelperService);

  transform(date: Date, is24Hours?: boolean): string {
    return this.helperService.convertDateToTime(date, is24Hours);
  }
}
